import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  const footerLinks = [
    { label: 'About Us', href: '/about' },
    { label: 'Affiliate Disclosure', href: '/affiliate-disclosure' },
    { label: 'Contact', href: '/contact' },
    { label: 'Privacy Policy', href: '/privacy' },
  ]

  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Tokyo Tourist Guide</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Your trusted resource for booking hotels, tours, and transport in Tokyo. 
              We help travelers find the best deals and experiences.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a 
                    href={link.href}
                    className="text-gray-400 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Popular Guides</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/jr-pass-alternatives" className="text-gray-400 hover:text-white text-sm transition-colors">
                  JR Pass Alternatives
                </Link>
              </li>
              <li>
                <Link to="/article/best-esim-japan" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Best eSIM for Japan
                </Link>
              </li>
              <li>
                <Link to="/article/shibuya-sky-tickets" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Shibuya Sky Tickets
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm">
          <p>© 2025 Tokyo Tourist Guide. All rights reserved.</p>
          <p className="mt-3 text-yellow-400 font-semibold">
            ⚠️ AFFILIATE DISCLOSURE: We earn commissions from qualifying purchases at no extra cost to you.
          </p>
          <p className="mt-2 text-xs text-gray-500">
            Amazon Associates & affiliate partner compliant. Last updated: January 2025.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
